import { Flex, Text } from "@chakra-ui/react";
import { Modal } from "antd";
import SelectableButton from "components/Button/SelectableButton";
import useGetTenantIntegracoes from "core/features/tenants/hooks/useGetTenantIntegracoes";
import { useState } from "react";
import "react-html5-camera-photo/build/css/index.css";
import FooterModal from "ui/components/Button/FooterModal";
import { useLoading } from "ui/components/GlobalLoading";
import CameraView from "./CameraView";
import FacialView from "./FacialView";
import { getCroppedImgBase64 } from "infra/helpers/crop";
import Cropper from "react-easy-crop";
import OutlineButton from "components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";
interface ModalCameraProps {
  visible: boolean;
  onClose: () => any;
  onSubmit: (uri: string) => any;
  croppable?: boolean;
}

interface CropArea {
  x: number;
  y: number;
  width: number;
  height: number;
}

function ModalCamera({
  visible,
  onClose,
  onSubmit,
  croppable = false,
}: ModalCameraProps) {
  const [preCropUri, setPreCropUri] = useState<string | undefined>();
  const [cropArea, setCropArea] = useState<CropArea | undefined>();
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const { data: tenantIntegracoes, isLoading: isLoadingTenantIntegracoes } =
    useGetTenantIntegracoes();
  const [view, setView] = useState<"camera" | "facial">("camera");

  useLoading(isLoadingTenantIntegracoes);

  const integradoComFacial =
    tenantIntegracoes?.intelbras && tenantIntegracoes?.intelbrasFaciais?.length;

  const _onSubmit = (uri: string) => {
    if (croppable) {
      setPreCropUri(uri);
    } else {
      onSubmit(uri);
      onClose();
    }
  };

  const onCropComplete = (
    _croppedArea: CropArea,
    croppedAreaPixels: CropArea
  ) => {
    setCropArea(croppedAreaPixels);
  };

  /* TODO: Verificar se existe algum erro possível aqui e tratar/avisar o usuário*/
  const onSubmitCrop = async () => {
    if (!preCropUri || !cropArea) {
      onClose();
      return;
    }

    const croppedBase64 = await getCroppedImgBase64(preCropUri, cropArea);

    if (!croppedBase64) {
      onClose();
      return;
    }

    onSubmit(croppedBase64);
    onClose();
  };

  return (
    <Modal
      destroyOnClose
      width="600px"
      footer={
        <FooterModal
          registerAnother={false}
          setRegisterAnother={() => null}
          onSubmit={() => {}}
          onClose={onClose}
          isLoadingSave={false}
          isDisabled={false}
          showRegisterAnother={false}
          primaryButtonText=""
          hidePrimaryButton
        />
      }
      centered
      bodyStyle={{
        borderRadius: 16,
        height: "80dvh",
      }}
      visible={visible}
      onCancel={onClose}
      closable={false}
    >
      {/* TODO: Separar esse componente*/}
      {preCropUri ? (
        <Flex
          flexDir="column"
          gap={4}
          flex={1}
          w="100%"
          h="100%"
          position="relative"
        >
          <Cropper
            image={preCropUri}
            crop={crop}
            zoom={zoom}
            aspect={3 / 4}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />

          <Flex
            h="40px"
            w="100%"
            px="16px"
            mt="auto"
            gap="16px"
            justifyContent="center"
            mb="16px"
          >
            <OutlineButton
              type="button"
              onClick={() => setPreCropUri(undefined)}
              title={"Voltar para etapa anterior"}
            >
              Voltar
            </OutlineButton>

            <PrimaryButton
              type="button"
              title={"Cortar"}
              onClick={onSubmitCrop}
            >
              Cortar
            </PrimaryButton>
          </Flex>
        </Flex>
      ) : null}
      {!preCropUri ? (
        <Flex flexDir="column" gap={4} flex={1} w="100%" h="100%">
          {integradoComFacial ? (
            <Flex
              flexDir="column"
              gap={4}
              alignItems="center"
              justifyContent="center"
            >
              <Text>Selecione o tipo de captura</Text>
              <Flex gap={4}>
                <SelectableButton
                  selected={view === "camera"}
                  onClick={() => setView("camera")}
                >
                  Camera
                </SelectableButton>
                <SelectableButton
                  selected={view === "facial"}
                  onClick={() => setView("facial")}
                >
                  Facial
                </SelectableButton>
              </Flex>
            </Flex>
          ) : null}

          {view === "camera" && <CameraView onSubmit={_onSubmit} />}

          {view === "facial" && integradoComFacial && (
            <FacialView
              faciais={tenantIntegracoes?.intelbrasFaciais}
              onSubmit={_onSubmit}
            />
          )}
        </Flex>
      ) : null}
    </Modal>
  );
}

export default ModalCamera;
